import { useQuery } from "@tanstack/react-query";
import { getCashTransactions } from "src/api/wallet";
import { QUERY_KEYS } from "../constants/queryKeys";
const useGetCashTransactions = (params)=>{
    return useQuery({
        queryKey: [
            QUERY_KEYS.CASH_TRANSACTION_LIST,
            params
        ],
        queryFn: ()=>getCashTransactions(params)
    });
};
export default useGetCashTransactions;
